import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import ColorPickerCheckboard from './color-picker-checkboard.vue.js';

var script = {
  name: 'ColorPickerSlider',
  components: {
    ColorPickerCheckboard
  },
  props: {
    valueKey: {
      type: String,
      required: true
    },
    color: {
      type: Object,
      required: true
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      oldValue: 0
    };
  },
  computed: {
    isAlpha() {
      return this.valueKey === 'alpha';
    },
    isHue() {
      return this.valueKey === 'h';
    },
    value() {
      if (this.isHue) {
        if (this.color.hsl.h === 0 && this.oldValue > 359) {
          return 360;
        }
        return this.color.hsl.h;
      }
      return this.color.alpha * 100;
    },
    gradientColor() {
      if (this.isHue) {
        return 'linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%)';
      }
      const rgb = `${this.color.r}, ${this.color.g}, ${this.color.b}`;
      return `linear-gradient(to right, rgba(${rgb}, 0) 0%, rgba(${rgb}, 1) 100%)`;
    }
  },
  methods: {
    onInput(event) {
      let value = event.target.valueAsNumber;
      if (this.isAlpha) {
        value /= 100;
      }
      this.oldValue = value;
      this.$emit('change', _objectSpread2(_objectSpread2({}, this.color.hsl), {}, {
        [this.valueKey]: value
      }));
    }
  }
};

export { script as default };
//# sourceMappingURL=color-picker-slider.vue2.js.map
